import { Profile } from '@interfaces/profile';
import AppContext from '@services/Context';
import { Button, Checkbox, Col, Row } from 'antd';
import React from 'react';

import I18n from '../../../../../i18n';

const CheckboxGroup = Checkbox.Group;

interface IProp {
  body: string
  receivers: Profile[]
  notifyFailed: boolean;
}

const clientName: string = "Eaton";

class NotificationHolderComponent extends React.Component<IProp, {}> {

  plainOptions: any = [];

  sendNotificationAgain() {
    console.log("Send notification here...");
  }

  getOptionsToShow(locale: any) {
    let options: string[] = []

    this.props.receivers.forEach(receiver => {
      options.push(this.getReceiverAsString(receiver, locale));
    });

    return options
  }

  getReceiverAsString(profile: Profile, locale: any) {
    switch (profile) {
      case Profile.UNIT:
        return clientName;

      case Profile.DISTRIBUTOR:
        return I18n.l('labels.distributor');

      case Profile.AGENT:
        return I18n.l('labels.agent');

      default:
        return "Error";
    }
  }

  getDefaultValues(locale: any) {
    let options: string[] = [
      clientName,
      I18n.l('labels.distributor'),
      I18n.l('labels.agent')
    ]

    return options
  }

  refactorHtmlString(htmlString: string) {
    // return htmlString.replace("<a ", "<a target='_blank'");
  }

  render(): JSX.Element {
    return (
      <AppContext.Consumer>
        {({ locale, theme }) => (
          <Row>
            <Col sm={24} md={24} xl={24}>
              <Row>
                <Col sm={24} md={24} xl={24}>
                  {
                    // renderHTML(this.refactorHtmlString(this.props.body))
                  }
                </Col>
              </Row>
              <Row>
                <Col sm={24} md={24} xl={24}>
                  <p>{I18n.l('titles.receivers')}</p>
                </Col>
              </Row>
              <Row>
                <Col sm={24} md={24} xl={24}>
                  <CheckboxGroup disabled options={this.getOptionsToShow(locale)} defaultValue={this.getDefaultValues(locale)} />
                </Col>
              </Row>
              {
                (!this.props.notifyFailed &&
                  <Row className="goepik-component-padding">
                    <Col sm={24} md={24} xl={24}>
                      <Button onClick={this.sendNotificationAgain}>{I18n.l('common.sendAgain')} {I18n.l('labels.notification')}</Button>
                    </Col>
                  </Row>
                )
              }
            </Col>
          </Row>
        )}
      </AppContext.Consumer>
    );
  }
};

export default NotificationHolderComponent;
